module.exports = __webpack_public_path__ + "img/HeaderRow1PlaceholderMobile.1b3f2153.svg";